import { config } from '@tshared/config/config'
import ky from 'ky'

export const reqPub = ky.create({
  timeout: 10000,
  hooks: {
    beforeRequest: [
      ({ request }) => {
        request.headers.set('x-ext-authz-sso-token-subdomain', config.getHeaderHost())
        return request
      },
    ],
  },
})

export default reqPub
